export const ru = {
    'add-additions-item-callouts': 'Добавить уточнения',
    'add-banners-display-hrefs': 'Добавить отображаемые ссылки',
    'add-creatives': 'Добавить креативы',
    'add-image-to-banner': 'Добавить изображения',
    'add-more-pictures-to-adgroup': 'Добавить изображения',
    'add-placements': 'Загрузить щиты',
    'add-site-links': 'Добавить быстрые ссылки',
    'add-title-extension': 'Добавить второй заголовок',
    'add-turbo-web-site-to-banner': 'Добавить Турбо-страницу',
    'all-platforms': 'На всех площадках',
    archived: 'В архиве',
    'autobudget-priority': 'Приоритет',
    avgClickCost: 'Средняя цена клика',
    avgCpmCost: 'Средняя цена за 1000 показов',
    avgGoalCost: 'CPA',
    'banner-body': 'Текст объявления',
    'banner-status-active': 'Активно',
    'banner-status-archived': 'В архиве',
    'banner-status-draft': 'Черновик',
    'banner-status-manually-suspended': 'Приостановлено',
    'banner-status-moderation': 'На модерации',
    'banner-status-moderation-rejected': 'Отклонено на модерации',
    'banner-status-temporarly-suspended': 'Временно приостановлено',
    'banner-title': 'Заголовок',
    'banner-title-extension': 'Расширение заголовка',
    'banner-type': 'Тип объявления',
    'banner-type-cpm_metro': 'Баннер в Яндекс Метро',
    'bid-modifiers': 'Корректировки ставок',
    both: 'На поиске и в сетях',
    'bounce-rate': 'Отказы',
    broadmatch: 'Дополнительные релевантные фразы',
    budgetLimit: 'Ограничение бюджета',
    'campaign-type': 'Тип кампании',
    'change-adgroup-for-moderation': 'Пройти модерацию',
    'change-adgroup-with-low-stat':
        'Исправить группы со статусом «Мало показов»',
    'change-banner-for-moderation': 'Пройти модерацию',
    clicks: 'Клики',
    context: 'В сетях',
    'context-price': 'Ставка (в сетях)',
    'converison-rate': '% конверсии',
    cost: 'Расход',
    cpa: 'CPA',
    cpc: 'CPC',
    cpm: 'CPM',
    ctr: 'CTR',
    'ctr-suggest': 'CTR который',
    'daily-budget': 'Повысить ограничение бюджета',
    'deal-id': 'Номер сделки',
    'deal-type': 'Тип сделки',
    disabled: 'Выключено',
    draft: 'Черновик',
    enabled: 'Включено',
    'finish-date': 'Дата окончания',
    goals: 'Конверсии',
    'group-status-active': 'Активна',
    'group-status-archived': 'В архиве',
    'group-status-draft': 'Черновик',
    'group-status-moderation': 'На модерации',
    'group-status-rejected': 'Отклонена на модерации',
    'group-status-stopped': 'Остановлена',
    'has-image': 'Изображение',
    'has-sitelinks': 'Быстрые ссылки',
    'has-turbolanding': 'Турбо-страницы',
    id: 'ID',
    keyword: 'Ключевые фразы',
    libraryMinusPhrasePacks: 'Наборы минус-фраз',
    metrics: 'Статистика',
    metrika: 'Счетчик Метрики',
    'min-price': 'Мин. цена тыс. показов',
    'minus-phrase-packs': 'Наборы минус-фраз',
    'moderation-denied': 'Отклонена на модерации',
    'moderation-pending': 'На модерации',
    'money-finished': 'Недостаточно средств',
    name: 'Название',
    'name-minus-phrase-packs': 'Название набора минус-фраз',
    'name-suggest': 'Название содержит',
    number: 'Номер',
    numberOfLinkedCampaigns: 'Количество привязанных кампаний',
    'phrase-status-active': 'Активна',
    'phrase-status-archived': 'В архиве',
    'phrase-status-draft': 'Черновик',
    'phrase-status-moderation-rejected': 'Отклонена на модерации',
    'phrase-status-suspended': 'Остановлена',
    platform: 'Места показов',
    price: 'Max цена клика',
    'price-context': 'Max цена клика (в сетях)',
    'price-context-cpm': 'Ставка за 1000 показов',
    profitability: 'ROI',
    recommendations: 'Рекомендации',
    'remove-page-from-blacklist': 'Включить качественные площадки',
    revenue: 'Доход',
    search: 'На поиске',
    'send-licenses': 'Отправить документы',
    'send-licenses-banks':
        'Отправить документы по тематике «Банковские услуги»',
    'send-licenses-med-services':
        'Отправить документы по тематике «Медицинские услуги»',
    'send-licenses-pharmacy':
        'Отправить документы по тематике «Аптеки и лекарства»',
    settings: 'Параметры',
    shows: 'Показы',
    'site-monitoring': 'Мониторинг сайта',
    spent: 'Расходы',
    'start-date': 'Дата начала',
    started: 'Запущена',
    'statistics-by-all-goals': 'По всем целям',
    status: 'Статус',
    stopped: 'Остановленная',
    strategy: 'Стратегия',
    sum: 'Осталось',
    'switch-on-autotargeting': 'Включить автотаргетинг',
    'target-funnel': 'Целевая аудитория',
    'temporarily-paused': 'Временно остановлена'
};
